import { Component, OnInit } from '@angular/core';
import { GlobalsService } from '../../common/services/globals.service';
import { TagContentType } from '@angular/compiler';

@Component({
  selector: 'sbe-app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class SbeFooterComponent implements OnInit {

  constructor(private _global: GlobalsService) { }

  get partner(){
    return GlobalsService.partner;
  }

  get TCLink() {
    if (GlobalsService.language == null || GlobalsService.language == '' || GlobalsService.language == 'EN') {
      return "../../../billing/paynow/assets/ePAY_T&C.pdf";
    } else if(GlobalsService.language == 'ES') {
       if(GlobalsService.partner === 'AHNJ') {
        return "../../../billing/paynow/assets/ES_ePAY_T&C.pdf";
      }
    }
  }

  get HELPLink() {
    if (GlobalsService.language == null || GlobalsService.language == '') {
      return "../../../billing/paynow/assets/" + GlobalsService.partner + "_" + 'EN' + "_HELP.html";
    } else {
      return "../../../billing/paynow/assets/" + GlobalsService.partner + "_" + GlobalsService.language + "_HELP.html";
    }
  }

  get GDPRLink() {
    return 'https://www.highmark.com/gdpr/';
  }

  get highMarkDomainStatus() {
    if(location.href.includes("highmark")) {
      return true;
    } else {
      return false;
    }
  }

  get FFMStatus() {
    if (location.href.includes("ffm")) {
      return true;
    } else {
      return false;
    }
  }

  get FFMTCLink() {
    if (location.href.includes("partner=wy")) {
      return "../../../billing/paynow/assets/ePAY_T&C.pdf";
    } else if (location.href.includes("partner=nd")) {
      return "../../../billing/paynow/assets/ePAY_T&C.pdf";
    } else {
      return "../../../billing/paynow/assets/ePAY_T&C.pdf";
    }
  }

  //to get the W3LL page status if the route contains w3ll
  get W3LLStatus() {
    if(location.href.includes("w3ll")) {
      return true;
    } else {
      return false;
    }
  }

  get activePartner() {
    return GlobalsService.activePartner;
  }

  ngOnInit() {
  }

}
